import { themeStyle } from '@src/theming';
import styled from 'styled-components';

export const ROUND_CLOSE_BUTTON_SIZE = 30;

export const RoundCloseButtonStyle = styled.div<{
  showOnMobile?: boolean;
}>`
  width: ${ROUND_CLOSE_BUTTON_SIZE}px;
  height: ${ROUND_CLOSE_BUTTON_SIZE}px;
  background: ${themeStyle.varBackgroundAlt};
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  position: absolute;
  cursor: pointer;
`;
